import {
  type SystemI18n,
  type UiI18n,
  type UiLibI18n,
} from '@myre/domain-i18n-wordings';
import {
  PRIMITIVE_CHARTS_WORDINGS,
  type PrimitiveChartsWordings,
} from '@myre/ui-primitive-charts';
import {
  PRIMITIVE_COMPONENTS_WORDINGS,
  type PrimitiveComponentsWordings,
} from '@myre/ui-primitive-components';
import {
  PRIMITIVE_CORE_WORDINGS,
  type PrimitiveCoreWordings,
} from '@myre/ui-primitive-core';
import {
  PRIMITIVE_FORMS_WORDINGS,
  type PrimitiveFormsWordings,
} from '@myre/ui-primitive-forms';
import {
  PRIMITIVE_MODAL_WORDINGS,
  type PrimitiveModalWordings,
} from '@myre/ui-primitive-modal';
import {
  PRIMITIVE_MULTI_TABLE_WORDINGS,
  type PrimitiveMultiTableWordings,
} from '@myre/ui-primitive-multi-table';
import {
  PRIMITIVE_TILES_WORDINGS,
  type PrimitiveTilesWordings,
} from '@myre/ui-primitive-tiles';
import {
  PRIMITIVE_TREE_TABLE_WORDINGS,
  type PrimitiveTreeTableWordings,
} from '@myre/ui-primitive-tree-table';

import { inject, type Provider } from '@angular/core';

import { WORDINGS } from './myre-wordings-loader';

/** The scopes every frontend loads on top of its own (`withFrontendLibs`). */
function frontendLibWordings(): UiI18n & UiLibI18n & SystemI18n {
  return inject<UiI18n & UiLibI18n & SystemI18n>(WORDINGS);
}

/**
 * Hands each primitive lib the wordings it declares. Every factory's return
 * type is that lib's contract, so a wording a primitive reads cannot be
 * renamed or deleted without this file failing to compile.
 */
export function providePrimitiveWordings(): Provider[] {
  return [
    {
      provide: PRIMITIVE_CHARTS_WORDINGS,
      useFactory: (): PrimitiveChartsWordings => frontendLibWordings(),
    },
    {
      provide: PRIMITIVE_COMPONENTS_WORDINGS,
      useFactory: (): PrimitiveComponentsWordings => frontendLibWordings(),
    },
    {
      provide: PRIMITIVE_CORE_WORDINGS,
      useFactory: (): PrimitiveCoreWordings => frontendLibWordings(),
    },
    {
      provide: PRIMITIVE_FORMS_WORDINGS,
      useFactory: (): PrimitiveFormsWordings => frontendLibWordings(),
    },
    {
      provide: PRIMITIVE_MODAL_WORDINGS,
      useFactory: (): PrimitiveModalWordings => frontendLibWordings(),
    },
    {
      provide: PRIMITIVE_MULTI_TABLE_WORDINGS,
      useFactory: (): PrimitiveMultiTableWordings => frontendLibWordings(),
    },
    {
      provide: PRIMITIVE_TILES_WORDINGS,
      useFactory: (): PrimitiveTilesWordings => frontendLibWordings(),
    },
    {
      provide: PRIMITIVE_TREE_TABLE_WORDINGS,
      useFactory: (): PrimitiveTreeTableWordings => frontendLibWordings(),
    },
  ];
}
